import React from 'react';
import { connect } from 'react-redux';
import { NumStepper } from '@nerdwallet/react-stepper';

import { AMORTIZATION } from '../../../lib/analytics-constants';
import { validationsSelector } from '../../../lib/selectors';
import {
  manualInputsSelector,
  inputsSelector,
} from '../../../lib/selectors/amortization-calculator-selector';
import {
  AmortizationInput,
  formatYears,
  inputOnChange,
} from '../../../lib/utils';
import { debouncedTrackInputEvent } from '../../../lib/analytics/trackers';
import useAnalytics from '../../../lib/analytics/use-analytics';

type OnChangeEvent = React.ChangeEvent<HTMLInputElement>;

type onInputChange = OnChangeEvent | number;

const LoanTermInput: React.FC<AmortizationInput> = ({
  manualInputs,
  inputs,
  dispatch,
  analytics,
}) => {
  const segmentAbstract = useAnalytics();
  // if inputType is RANGE we need to set a default value, so taking placeholder if needed
  const placeholder = inputs?.loanTerm;
  const value = manualInputs?.loanTerm ?? placeholder;
  const analyticsEnabled = analytics && analytics?.enabled;
  const bedrockAnalytics =
    analyticsEnabled && analytics?.payload?.bedrock?.eventType;

  const onInputChange = (e: onInputChange) => {
    let bedrock;
    if (bedrockAnalytics) {
      const bedrockProps = analytics?.payload?.bedrock;
      bedrock = {
        ...bedrockProps,
        valueFieldName: 'value_i',
      };
    }

    // segment analytics
    debouncedTrackInputEvent(
      {
        field_type: 'increment-decrement-user_type_input',
        entityName: 'loan_term',
        field: 'Loan Term',
        field_value: e,
      },
      segmentAbstract
    );

    inputOnChange({
      event: e,
      dispatch,
      bedrock,
      fieldName: 'loanTerm',
      calculator: AMORTIZATION,
      inputType: 'number',
    });
  };

  return (
    <NumStepper
      editable
      formatter={formatYears}
      max={30}
      min={1}
      stepSize={1}
      value={value}
      onChange={onInputChange}
    />
  );
};

const mapStateToProps = (state) => ({
  manualInputs: manualInputsSelector(state),
  inputs: inputsSelector(state),
  validations: validationsSelector(state),
});

export default connect(mapStateToProps)(LoanTermInput);
